import InteractiveChart from "./InteractiveChart";

export default InteractiveChart;
